import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const tagsUrl = `${SERVER_API}/tags`;

export const TAGS = {
  SUBSCRIPTION: {
    method: 'POST',
    url: `${tagsUrl}/event/subscription`,
  } as IEndpointData,
  PUBLIC: {
    method: 'GET',
    url: `${SERVER_API}/public/tags`
  }
};
